import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "API", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "Your API token:", -1)
const _hoisted_4 = { class: "block text-blue-300" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", null, "Statistics", -1)
const _hoisted_6 = { class: "block" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 font-bold" }, "Available params:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("api_token"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-pink-300" }, "Required")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("date_from"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(Y-m-d)")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("date_to"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(Y-m-d)")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("date"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(Y-m-d)")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, "endpoint_id[]", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, "subid", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, "page", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("entries_per_page"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(100 by default)")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 font-bold" }, "Example:", -1)
const _hoisted_17 = { class: "mb-4" }
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h4", null, "Statistics", -1)
const _hoisted_20 = { class: "block" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 font-bold" }, "Available params:", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("api_token"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-pink-300" }, "Required")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("date_from"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(Y-m-d)")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("date_to"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(Y-m-d)")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("date"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(Y-m-d)")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", null, "endpoint_id[]", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", null, "subid", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", null, "page", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("entries_per_page"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(100 by default)")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 font-bold" }, "Example:", -1)
const _hoisted_31 = { class: "mb-4" }
const _hoisted_32 = ["href"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h4", null, "Statistics", -1)
const _hoisted_34 = { class: "block" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 font-bold" }, "Available params:", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("api_token"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-pink-300" }, "Required")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("date_from"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(Y-m-d)")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("date_to"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(Y-m-d)")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("date"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(Y-m-d)")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", null, "campaign_id[]", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", null, "page", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("entries_per_page"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-indigo-300" }, "(100 by default)")
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 font-bold" }, "Example:", -1)
const _hoisted_44 = { class: "mb-4" }
const _hoisted_45 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueTabPanel = _resolveComponent("PrimeVueTabPanel")!
  const _component_PrimeVueTabView = _resolveComponent("PrimeVueTabView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("code", _hoisted_4, _toDisplayString(_ctx.user.api_token), 1),
    _createVNode(_component_PrimeVueTabView, { class: "mt-2" }, {
      default: _withCtx(() => [
        _createVNode(_component_PrimeVueTabPanel, { header: "Direct publishers API" }, {
          default: _withCtx(() => [
            _hoisted_5,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statisticsDirectPublisher, (statistic, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("h5", null, _toDisplayString(statistic.title), 1),
                _createElementVNode("code", _hoisted_6, "https://api." + _toDisplayString(_ctx.user.project.host) + "/api/statistics/publisher/direct/" + _toDisplayString(statistic.method), 1),
                _hoisted_7,
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _hoisted_11,
                _hoisted_12,
                _hoisted_13,
                (statistic.method === 'getStatisticsBySubids')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_14,
                      _hoisted_15
                    ], 64))
                  : _createCommentVNode("", true),
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("a", {
                    href: `https://api.${_ctx.user.project.host}/api/statistics/publisher/direct/${statistic.method}?api_token=${_ctx.user.api_token}&date_from=${_ctx.dateFrom}&date_to=${_ctx.dateTo}`,
                    target: "_blank"
                  }, "https://api." + _toDisplayString(_ctx.user.project.host) + "/api/publisher/direct/" + _toDisplayString(statistic.method) + "?api_token=" + _toDisplayString(_ctx.user.api_token) + "&date_from=" + _toDisplayString(_ctx.dateFrom) + "&date_to=" + _toDisplayString(_ctx.dateTo), 9, _hoisted_18)
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_PrimeVueTabPanel, { header: "RTB publishers API" }, {
          default: _withCtx(() => [
            _hoisted_19,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statisticsRTBPublisher, (statistic, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("h5", null, _toDisplayString(statistic.title), 1),
                _createElementVNode("code", _hoisted_20, "https://api." + _toDisplayString(_ctx.user.project.host) + "/api/statistics/publisher/rtb/" + _toDisplayString(statistic.method), 1),
                _hoisted_21,
                _hoisted_22,
                _hoisted_23,
                _hoisted_24,
                _hoisted_25,
                _hoisted_26,
                _hoisted_27,
                (statistic.method === 'getStatisticsBySubids')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_28,
                      _hoisted_29
                    ], 64))
                  : _createCommentVNode("", true),
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("a", {
                    href: `https://api.${_ctx.user.project.host}/api/statistics/publisher/rtb/${statistic.method}?api_token=${_ctx.user.api_token}&date_from=${_ctx.dateFrom}&date_to=${_ctx.dateTo}`,
                    target: "_blank"
                  }, "https://api." + _toDisplayString(_ctx.user.project.host) + "/api/statistics/publisher/rtb/" + _toDisplayString(statistic.method) + "?api_token=" + _toDisplayString(_ctx.user.api_token) + "&date_from=" + _toDisplayString(_ctx.dateFrom) + "&date_to=" + _toDisplayString(_ctx.dateTo), 9, _hoisted_32)
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_PrimeVueTabPanel, { header: "Advertisers API" }, {
          default: _withCtx(() => [
            _hoisted_33,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statisticsAdvertiser, (statistic, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("h5", null, _toDisplayString(statistic.title), 1),
                _createElementVNode("code", _hoisted_34, "https://api." + _toDisplayString(_ctx.user.project.host) + "/api/statistics/advertiser/" + _toDisplayString(statistic.method), 1),
                _hoisted_35,
                _hoisted_36,
                _hoisted_37,
                _hoisted_38,
                _hoisted_39,
                _hoisted_40,
                (statistic.method === 'getStatisticsBySubids')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_41,
                      _hoisted_42
                    ], 64))
                  : _createCommentVNode("", true),
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("a", {
                    href: `https://api.${_ctx.user.project.host}/api/statistics/advertiser/${statistic.method}?api_token=${_ctx.user.api_token}&date_from=${_ctx.dateFrom}&date_to=${_ctx.dateTo}`,
                    target: "_blank"
                  }, "https://api." + _toDisplayString(_ctx.user.project.host) + "/api/statistics/advertiser/" + _toDisplayString(statistic.method) + "?api_token=" + _toDisplayString(_ctx.user.api_token) + "&date_from=" + _toDisplayString(_ctx.dateFrom) + "&date_to=" + _toDisplayString(_ctx.dateTo), 9, _hoisted_45)
                ])
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}